// A testing APP ID
export const APP_ID = 'LAWwebsite';
